import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import PrivateRoute from "./utils/PrivateRoute";
import { useKeycloak } from "@react-keycloak/web";

import Editor from "./pages/Editor";
// import Login from "./pages/Login";

import TemplateManager from "./pages/TemplateManager";
import EDetails from "./pages/EDetails";

import NewEdetail from "./pages/CreateEdetail";
import "./css/common.scss";
import TemplatePreview from "./pages/TemplatePreview";
import EditorWrapper from "./pages/EditorWrapper";
import ModuleSelectionPage from "./pages/ModuleSelectionPage";
import TemplateExport from "./pages/TemplateExport";
import ImportPDFPage from "./pages/ImportPDFPage";
import PreviewConvertPage from "./pages/PreviewConvertPage";
import PdfEditor from "./pages/PdfEditor";
import GlobaleEventListener from "./utils/GlobaleEventListener";
import ServerMaintenance from "./pages/ServerMaintenance";
import WebActionVeevaRedirect from "./routes/WebActionVeevaRedirect";

function AppRouter() {
  const { initialized } = useKeycloak();

  if (!initialized) {
    return <div>Loading...</div>;
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route
            path="/template-manager"
            element={
              <PrivateRoute>
                {/* <TemplateManager /> */}
                <GlobaleEventListener />
                <EDetails categoryType="1" />
              </PrivateRoute>
            }
          />
          <Route
            path="/edetail-manager"
            element={
              <PrivateRoute>
                <GlobaleEventListener />
                <EDetails categoryType="2" />
              </PrivateRoute>
            }
          />
          <Route
            path="/"
            element={
              <Navigate to="/edetail-manager" replace />
            }
          />
          <Route
            path="/create-edetail"
            element={
              <PrivateRoute>
                <NewEdetail />
              </PrivateRoute>
            }
          />
          <Route
            path="/editor/:pageId"
            element={
              <PrivateRoute>
                <GlobaleEventListener />
                <Editor />
              </PrivateRoute>
            }
          />
          <Route
            path="/module"
            element={
              <PrivateRoute>
                <ModuleSelectionPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/webaction"
            element={
              <WebActionVeevaRedirect />
            }
          />
          <Route
            path="/template-preview"
            element={
              <PrivateRoute>
                <TemplatePreview />
              </PrivateRoute>
            }
          />
          <Route
            path="/template-export"
            element={
              <PrivateRoute>
                <TemplateExport />
              </PrivateRoute>
            }
          />
          <Route path="/server-maintenance" element={<ServerMaintenance />}
          />
          <Route
            path="/import-pdf"
            element={
              <PrivateRoute>
                <ImportPDFPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/preview-convert"
            element={
              <PrivateRoute>
                <PreviewConvertPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/pdf-editor/:deckId"
            element={
              <PrivateRoute>
                <PdfEditor />
              </PrivateRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default AppRouter;
